var jade = require("/var/lib/jenkins-code/academia-app/node_modules/.pnpm/jade@1.11.0/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"top_banner_flash orange\"><i class=\"close\">&times;</i><a href=\"/settings#privacy-settings\" class=\"action\">Settings</a><p class=\"message\">Did you know you can prevent your downloads from being automatically bookmarked? Visit your" + (jade.escape(null == (jade_interp = ' ') ? "" : jade_interp)) + "<a href=\"/settings#privacy-settings\">Privacy Settings.</a></p></div>");;return buf.join("");
}